// useAuth.ts
import { useContext, useState } from "react";
import { AuthContext } from "../Providers/AuthProvider"; // Ensure correct path
import { auth } from "../firebase"; // Import auth from your Firebase configuration
import {
	signInWithEmailAndPassword,
	signInWithPopup,
	GoogleAuthProvider,
} from "firebase/auth";
import createClient from "../Helpers/apiClient";
import { AxiosError } from "axios";

export const useAuth = () => {
	const { user } = useContext(AuthContext);
	const [error, setError] = useState<string | null>(null);
	const [successMessage, setSuccessMessage] = useState<string | null>(null);

	const signIn = async (email: string, password: string) => {
		await signInWithEmailAndPassword(auth, email, password)
			.then(() => setError(null))
			.catch(() => {
				setError("Invalid username or password");
			});
	};

	const signInWithGoogle = async () => {
		// Implement Google Sign In
		const provider = new GoogleAuthProvider();

		signInWithPopup(auth, provider)
			.then(result => {
				setError(null);
			})
			.catch(error => {
				const errorMessage = error.message;
				console.log(`Error: ${errorMessage}`);
			});
	};

	const deleteUserAccount = async () => {
		const client = createClient();

		if (!user) {
			setError("User not found. Please log in.");
			return;
		}

		client
			.delete(`/users/${user.uid}`, { params: { email: user.email } })
			.then(response => {
				setSuccessMessage("Account Deleted Successfully!");
				setError(null);
			})
			.catch((error: AxiosError) => {
				if (error.response) {
					console.log(error.response.status);
				}
				setError("Could not delete account. Please try again.");
			});
	};

	return {
		user,
		signIn,
		signInWithGoogle,
		deleteUserAccount,
		error,
		successMessage,
	};
};
